import React, { Fragment, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import ItemDetails from 'components/ItemDetails'
import { isEmpty } from 'lodash'
import usePrevious from '../../utils/previousHook'
import { Box } from '@material-ui/core'
import ItemsList from 'components/ItemsList'
import classnames from 'clsx'
import EngagementsBoard from 'components/EngagementsBoard'
import DonationsMessage from 'components/DonationsMessage'

const VideoOverlay = ({
  itemDetailsOpen,
  setItemDetailsOpen,
  eventDetailsOpen,
  setEventDetailsOpen
}) => {
  const classes = useStyles()
  const orientation = useSelector(state => state.window.orientation)
  const [reRender, setReRender] = useState(false)
  const event = useSelector(state => state.event.event)
  const liveSettings = event.live_settings
  // change to actual value later event.mode?
  const donateMode = Number(event.live_settings.live_mode) === 1
  const previousDonateMode = usePrevious(donateMode)
  const currentItem = useSelector(state => {
    const item = state.items.items.find(i => i.is_live)
    if (item) {
      return item
    } else {
      return {}
    }
  })

  useEffect(() => {
    if (previousDonateMode !== donateMode) {
      setEventDetailsOpen(!donateMode)
    }
  }, [donateMode, previousDonateMode])

  if (reRender) {
    setReRender(false)
  }

  return (
    <Box className={classnames(classes.contentBox, classes[orientation])}>
      {liveSettings.show_engagements && (
        <Fragment>
          {liveSettings.show_chat && (
            <EngagementsBoard item={currentItem} donateMode={donateMode} />
          )}
          {!liveSettings.show_chat && (
            <Fragment>
              {(!isEmpty(currentItem) || donateMode) && (
                <EngagementsBoard item={currentItem} donateMode={donateMode} />
              )}
              {isEmpty(currentItem) && !donateMode && <ItemsList />}
            </Fragment>
          )}
        </Fragment>
      )}
      {!liveSettings.show_engagements && (
        <Fragment>
          {donateMode && <DonationsMessage />}
          {!donateMode && (
            <Fragment>
              {isEmpty(currentItem) && <ItemsList />}
              {!isEmpty(currentItem) && <ItemDetails />}
            </Fragment>
          )}
        </Fragment>
      )}
    </Box>
  )
}

export default VideoOverlay



// WEBPACK FOOTER //
// ./src/components/Content/index.jsx